import {
    AccessLevel,
    ICorporationResponse,
    ICurrentUserResponse,
    ILocationResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { useAccess } from 'contexts/AccessContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { useCallback } from 'react';
import { useHistory } from 'react-router';
import {
    determineCorporationNavigationRoute,
    determineGlobalNavigationRoute,
    determineLocationNavigationRoute,
    getCorporationLandingPageRoute,
    getHardwareRoute,
} from 'utils/RouteHelper';

export const useScopeNavigation = (user: ICurrentUserResponse | undefined) => {
    const history = useHistory();
    const { canViewCorporationMap } = usePermissions();
    const { isPremium } = useAccess();

    const navigateToCorporationPage = useCallback(
        (newCorporation: ICorporationResponse) => {
            // If switching from a Corporation with premium access to a
            // Corporation with basic access, redirect to the new Corporation's
            // Hardware page (default page for Basic Corporations).
            if (newCorporation.AccessLevel === AccessLevel.Basic) {
                history.push(getHardwareRoute(newCorporation.Id));
            } else {
                const url = determineCorporationNavigationRoute(
                    history.location.pathname,
                    newCorporation.Id,
                    true
                );
                if (url.includes('maps') && !canViewCorporationMap) {
                    history.push(getCorporationLandingPageRoute(newCorporation.Id));
                } else {
                    history.push(url);
                }
            }
        },
        [canViewCorporationMap, history]
    );

    const navigateToLocationPage = useCallback(
        (newLocation: ILocationResponse) => {
            history.push(
                determineLocationNavigationRoute(
                    history.location.pathname,
                    newLocation.Id,
                    isPremium
                )
            );
        },
        [isPremium, history]
    );

    const navigateToGlobalPage = useCallback(() => {
        history.push(determineGlobalNavigationRoute(history.location.pathname, user));
    }, [history, user]);

    return {
        globalUrl: user
            ? determineGlobalNavigationRoute(history.location.pathname, user)
            : '/',
        navigateToCorporationPage,
        navigateToLocationPage,
        navigateToGlobalPage,
    };
};
